import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function EbookDetails() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Despertar de los Dos Hemisferios',
    desc: 'ChatGPT vs DeepSeek. Qué es cada uno, para qué sirve cada uno y cómo usarlos juntos como un sistema de dos cerebros.',
    color: 'border-blue-500/30',
    bg: 'bg-blue-500/5'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Ingeniería de Prompts y Workflows Avanzados',
    desc: 'El sistema R-C-O-P, el Chain Prompting y los flujos de trabajo que convierten prompts sueltos en resultados profesionales.',
    color: 'border-brand/30',
    bg: 'bg-brand/5'
  }, {
    icon: '📙',
    title: 'Tomo 3 — El Trabajador Aumentado',
    desc: 'Cómo delegar el 70% de tus tareas administrativas: correos, reportes, minutas, planes y presentaciones. Recupera 10 horas semanales.',
    color: 'border-orange-500/30',
    bg: 'bg-orange-500/5'
  }, {
    icon: '📕',
    title: 'Tomo 4 — La Máquina de Contenidos',
    desc: 'Domina algoritmos y persuade audiencias. Copywriting con IA, ciclo de reutilización de contenido y estrategia de marketing completa.',
    color: 'border-red-500/30',
    bg: 'bg-red-500/5'
  }, {
    icon: '📓',
    title: 'Tomo 5 — El Aprendiz Infinito',
    desc: 'Aprende cualquier habilidad, idioma o concepto técnico en el 20% del tiempo. El método Feynman con IA y el tutor socrático.',
    color: 'border-purple-500/30',
    bg: 'bg-purple-500/5'
  }, {
    icon: '📔',
    title: 'Tomo 6 — El Protocolo de Ejecución',
    desc: 'Tu plan de 30 días con rutinas, hábitos y el sistema "1% diario" para convertir el conocimiento en resultados medibles.',
    color: 'border-yellow-500/30',
    bg: 'bg-yellow-500/5'
  }];
  const features = ['Sistema paso a paso listo para implementar hoy', 'Prompts reales probados (no genéricos de internet)', 'Ejercicios interactivos y worksheets completables', 'Comparativas DeepSeek vs ChatGPT por tipo de tarea', 'Ejemplos con capturas y resultados reales', 'Checklists de verificación de calidad', 'Glosario técnico en español neutro', '100% ejecutable desde el primer día sin experiencia previa'];
  return <section className="py-16 px-4" data-id="element-67">
      <div className="max-w-6xl mx-auto" data-id="element-68">
        <div className="text-center mb-16" data-id="element-69">
          <h2 className="text-3xl font-heading font-bold text-white mb-2" data-id="element-70">
            🤖 6 TOMOS COMPLETOS
          </h2>
          <p className="text-brand font-medium" data-id="element-71">Principiante → Avanzado</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-72">
          {tomos.map((tomo, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className={`bg-surface border ${tomo.color} ${tomo.bg} rounded-2xl p-6`} data-id="element-73">
              <div className="text-4xl mb-4" data-id="element-74">{tomo.icon}</div>
              <h3 className="text-xl font-heading font-bold text-white mb-3" data-id="element-75">
                {tomo.title}
              </h3>
              <p className="text-gray-300 leading-relaxed text-sm" data-id="element-76">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-surface border border-border rounded-2xl p-8 md:p-12 max-w-4xl mx-auto" data-id="element-77">
          <h4 className="font-bold text-xl text-white mb-6 text-center" data-id="element-78">
            Cada tomo incluye:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-79">
            {features.map((feature, fIdx) => <div key={fIdx} className="flex items-start gap-3" data-id="element-80">
                <CheckCircle2 className="text-brand shrink-0 mt-0.5" size={20} data-id="element-81" />
                <span className="text-gray-300" data-id="element-82">{feature}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}